import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../context/user/context";
import { IUser } from "../../../models/user/response";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import {  tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import Tag from "../../general/antd/tag";
import TrademarkManagerContext from "../../../context/trademark-manager/context";
import { ITrademarkManager } from "../../../models/trademark-manager/response";
import { getUserStatus, getUserStatusColor } from "../../../models/user/enum";

interface IProps {}

const TradeManagerTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(TrademarkManagerContext);

  const columns: ColumnProps<ITrademarkManager>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("first_name"),
      dataIndex: "firstName",
      align: "center",
      sorter: {
        multiple: 2,
      },
      key: "firstName",
      render: (_, record) => {
        return record?.user?.firstName;
      },
    },
    {
      title: t("last_name"),
      dataIndex: "lastName",
      sorter: {
        multiple: 3,
      },
      align: "center",
      key: "lastName",
      render: (_, record) => {
        return record?.user?.lastName;
      },
    },
    {
      title: t("mobile"),
      dataIndex: "mobile",
      align: "center",
      key: "mobile",
      render: (_, record) => {
        return record?.user?.cleanMobile ?? "-";
      },
    },
    {
      title: t("charity"),
      dataIndex: "charity",
      align: "center",
      key: "charity",
      render: (_, record) => {
        return record?.charity?.name ?? "-";
      },
    },
    {
      title: t("status"),
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_, record) => {
        return (
          <Tag
            title={getUserStatus(record?.user?.status)}
            color={getUserStatusColor(record?.user?.status)}
          />
        );
      },
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
            onClick={async () => {
              navigate(`details/${record?.id}`);
            }}
          />
          <EditBtn
            onClick={async () => {
              navigate(`update/${record?.id}`);
            }}
          />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteTradmarkManager(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list")}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default TradeManagerTable;
